var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4259 24.7592L37.051 22.0577L31.6448 17.3686L43.2008 6.39964L40.604 4.7998L11.4569 18.8062L16.5742 23.2404L10.951 25.9419L16.3563 30.6296L4.80078 41.6L7.39518 43.1998L36.5446 29.1948L31.4259 24.7592Z",
    fill: "#BA8926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIcon10);
export default __webpack_public_path__ + "static/media/m-icon10.afa5c399c6cb3ae98e445c85ecca9130.svg";
export { ForwardRef as ReactComponent };